export const FETCH_USER_ACTIVITY_REQUEST = 'FETCH_USER_ACTIVITY_REQUEST';
export const FETCH_USER_ACTIVITY_SUCCESS = 'FETCH_USER_ACTIVITY_SUCCESS';
export const FETCH_USER_ACTIVITY_FAILURE = 'FETCH_USER_ACTIVITY_FAILURE';
export const CLEAR_USER_ACTIVITY         = 'CLEAR_USER_ACTIVITY';
